export const RANGES = {
  "7_days": "7_days",
  "30_days": "30_days",
  all_time: "all_time",
};

export type Range = keyof typeof RANGES;

export const DEFAULT_RANGE: Range = "7_days";

export const RANK_ICONS: Record<number, { light: string; dark: string }> = {
  1: { light: "leaderboard-rank-1", dark: "leaderboard-rank-1-dark" },
  2: { light: "leaderboard-rank-2", dark: "leaderboard-rank-2-dark" },
  3: { light: "leaderboard-rank-3", dark: "leaderboard-rank-3-dark" },
};
